import { Grid } from "@mui/material";
import { Input } from "controls";
import React from "react";

const ContactInfo = ({ values, errors, handleInpChg }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Input
          label="First Name"
          name="firstName"
          required={true}
          value={values.firstName}
          error={errors.firstName}
          inputProps={{ maxLength: 255 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Last Name"
          name="lastName"
          required={true}
          value={values.lastName}
          error={errors.lastName}
          inputProps={{ maxLength: 255 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Email"
          name="email"
          required={true}
          value={values.email}
          error={errors.email}
          inputProps={{ maxLength: 200 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Phone"
          name="phone"
          required={true}
          value={values.phone}
          inputProps={{ maxLength: 50 }}
          error={errors.phone}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Website"
          name="website"
          value={values.website}
          inputProps={{ maxLength: 600 }}
          onChange={handleInpChg}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Input
          label="Twitter"
          name="twitter"
          value={values.twitter}
          inputProps={{ maxLength: 600 }}
          onChange={handleInpChg}
        />
      </Grid>
    </Grid>
  );
};

export default ContactInfo;
